import { StyleSheet } from 'react-native';
import { Buttons } from 'src/theme-v2/buttons';
import { Spacing } from 'src/theme-v2/spacing';
import { textLatoStyleDS } from 'src/theme-v2/text';
import { neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  buttonsWrapper: {
    flexDirection: 'row',
    gap: Spacing.Condensed,
    justifyContent: 'flex-end',
    marginHorizontal: 'auto',
    paddingHorizontal: 16,
    position: 'absolute',
    top: 0,
  },
  actionButton: {
    width: 36,
    height: 36,
    borderRadius: 50,
    backgroundColor: neutrals.white,
    shadowColor: neutrals.black,
    shadowOpacity: 0.15,
    shadowOffset: {
      width: 1,
      height: 1,
    },
    shadowRadius: 6,
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    color: Buttons.quaternaryOnDark.ButtonQuaternaryOnDarkIconDefault,
  },
  hoveredTooltipContentIconContainer: {
    marginTop: 20,
  },
  hoveredTooltipContentIcon: {
    padding: Spacing.Condensed,
    ...textLatoStyleDS.BodyBoldXs,
  },
});
